import Vue from "vue";
import App from "./App.vue";
import {
  Uploader,
  Button,
  Field,
  Image,
  Row,
  Col,
  Cell
 ,Sidebar,popup,
  CellGroup, Picker, Popup, DatetimePicker, DropdownMenu, DropdownItem, Overlay ,Progress,Form, Dialog, icon,SwipeCell, Toast,Tab,Tabs,Area,PullRefresh ,Divider ,RadioGroup, Radio
} from "vant";
import "amfe-flexible/index.js";
import router from "./router";
import axios from 'axios'

Vue.prototype.$http = axios
// 引入Echarts
import Echarts from 'echarts'
Vue.prototype.echarts = Echarts
Vue.use(Echarts)

Vue.use(Uploader)
  .use(Button)
  .use(Field)
  .use(Image)
  .use(Row)
  .use(Col)
  .use(Cell)
 .use(Sidebar).use(popup)
  .use(CellGroup).use(Picker).use(Popup).use(DatetimePicker).use(Progress).use(PullRefresh).use(Divider ).use(icon).use(Form)
 .use(Form)
 .use(RadioGroup)
 .use(Radio)
  .use(CellGroup).use(Picker).use(Popup).use(DatetimePicker).use(Progress).use(PullRefresh).use(Divider ).use(icon)
  .use(Dialog).use(SwipeCell).use(Toast).use(Tab).use(Tabs).use(Area).use(Overlay ).use(DropdownItem).use(DropdownMenu);

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  console.log("to", to);
 
  if (to.name) {
    setTimeout(function () {
      document.title = to.name;
      var mobile = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(mobile)) {
        var iframe = document.createElement("iframe");
        iframe.style.display = "none";
        // 替换成站标favicon路径或者任意存在的较小的图片即可
        iframe.setAttribute("src", "/favicon.ico");
        var iframeCallback = function () {
          setTimeout(function () {
            iframe.removeEventListener("load", iframeCallback);
            document.body.removeChild(iframe);
          }, 0);
        };
        iframe.addEventListener("load", iframeCallback);
        document.body.appendChild(iframe);
      }
    })

  }
  next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
